import type { EngagementScope } from '../../../src/reports/shared/engagement-scope';

interface Props {
  value: EngagementScope;
  onChange(value: EngagementScope): void;
  accounts: string[];
  statuses?: string[];
}

export function EngagementScopeFilters({ value, onChange, accounts, statuses = [] }: Props): JSX.Element {
  const statusOptions = [...new Set(['Active', 'On Hold', 'Completed', 'Cancelled', '(blank)', ...statuses])];
  const accountOptions = [...new Set(['AbbVie', ...accounts, ...value.accounts.values])].sort();
  const toggle = (values: string[], item: string) => values.includes(item) ? values.filter((v) => v !== item) : [...values, item];
  return (
    <div className="toolbar" style={{ alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>
      <details>
        <summary>Engagement status · {value.statuses.join(', ') || 'All statuses'}</summary>
        <div className="chk-list" style={{ marginTop: 8 }}>
          <button className="btn-link" onClick={() => onChange({ ...value, statuses: [] })}>All statuses</button>
          {statusOptions.map((status) => <label key={status}>
            <input type="checkbox" checked={value.statuses.includes(status)} onChange={() => onChange({ ...value, statuses: toggle(value.statuses, status) })} />
            {status}
          </label>)}
        </div>
      </details>
      <details>
        <summary>Reporting accounts · {value.accounts.mode === 'all' ? 'All' : `${value.accounts.mode} ${value.accounts.values.length}`}</summary>
        <select className="select" aria-label="Account selection mode" value={value.accounts.mode}
          onChange={(e) => onChange({ ...value, accounts: { ...value.accounts, mode: e.target.value as EngagementScope['accounts']['mode'] } })}>
          <option value="all">All accounts</option><option value="include">Include selected</option><option value="exclude">Exclude selected</option>
        </select>
        <div className="chk-list" style={{ maxHeight: 200, overflow: 'auto' }}>
          {accountOptions.map((account) => <label key={account}>
            <input type="checkbox" disabled={value.accounts.mode === 'all'} checked={value.accounts.mode === 'all' || value.accounts.values.includes(account)}
              onChange={() => onChange({ ...value, accounts: { ...value.accounts, values: toggle(value.accounts.values, account) } })} />
            {account}
          </label>)}
        </div>
      </details>
      <button className="btn-link" onClick={() => onChange({ ...value, accounts: { mode: 'exclude', values: [...new Set([...(value.accounts.mode === 'exclude' ? value.accounts.values : []), 'AbbVie'])] } })}>Exclude AbbVie</button>
      <button className="btn-link" onClick={() => onChange({ statuses: ['Active'], accounts: { mode: 'all', values: [] } })}>Reset to Active</button>
    </div>
  );
}
